var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"is-flex is-vcentered columns",staticStyle:{"margin":"0","color":"#088"},attrs:{"href":_vm.metadata.metadataUrl,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.metadata.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }